// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'DM Sans', sans-serif;
}

option {
  color: black;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  padding: 2px;
}

::-webkit-scrollbar-thumb {
  background-color: #98d795;
  border-radius: 10px;
  height: 5px;
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #e0e6eb;
  width: 5px;
  height: 5px;
  padding: 2px;
  box-shadow: rgb(183, 197, 210) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ;oDACkD;AACpD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');\nbody {\n  font-family: 'DM Sans', sans-serif;\n}\n\noption {\n  color: black;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  padding: 2px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #98d795;\n  border-radius: 10px;\n  height: 5px;\n  width: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #e0e6eb;\n  width: 5px;\n  height: 5px;\n  padding: 2px;\n  box-shadow: rgb(183, 197, 210) 3px 3px 6px 0px inset,\n    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
